"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _groupEmail = _interopRequireDefault(require("../../../../core/group-email"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Flag Filters
// *******************************************************************************

const flags = [{
  id: 'hasPaid',
  description: 'Paid',
  trueLabel: 'Has Paid',
  falseLabel: 'Has Not Paid',
  canClear: true,
  enabled: entries => entries.some(e => e.hasPaid) && entries.some(e => !e.hasPaid),
  check: (state, entry) => state.hasPaid === null || entry.hasPaid === state.hasPaid
}, {
  id: 'isLate',
  description: 'Late Entry',
  trueLabel: 'Late Entry',
  falseLabel: 'On Time',
  canClear: true,
  enabled: entries => entries.some(e => e.isLate) && entries.some(e => !e.isLate),
  check: (state, entry) => state.isLate === null || entry.isLate === state.isLate
}, {
  id: 'hasRTC',
  description: 'RTC',
  trueLabel: 'Has RTC',
  falseLabel: 'No RTC',
  canClear: true,
  enabled: entries => entries.some(e => e.rtcRefs.length) && entries.some(e => !e.rtcRefs.length),
  check: (state, entry) => state.hasRTC === null || !!entry.rtcRefs.length === state.hasRTC
}, {
  id: 'isOnlineEntry',
  description: 'Online',
  trueLabel: 'Entered Online',
  falseLabel: 'Postal Entry',
  canClear: true,
  enabled: entries => entries.some(e => e.isOnlineEntry) && entries.some(e => !e.isOnlineEntry),
  check: (state, entry) => state.isOnlineEntry === null || entry.isOnlineEntry === state.isOnlineEntry
}, {
  id: 'isLateEntry',
  description: 'Late Entry',
  trueLabel: 'Late Entry',
  falseLabel: 'On-time',
  canClear: true,
  enabled: entries => entries.some(e => e.isLateEntry) && entries.some(e => !e.isLateEntry),
  check: (state, entry) => state.isLateEntry === null || entry.isLateEntry === state.isLateEntry
}];

// *******************************************************************************
// Filter Sets
// *******************************************************************************

const filterSets = props => [{
  id: 'includeDivisions',
  description: 'Competition Divisions',
  options: (state, filteredEntries) => props.competitionDivisions.filter(div => filteredEntries.some(e => e.competitionDivisionID === div.id) || state.includeDivisions.indexOf(div.id) > -1),
  check: (state, entry) => !state.includeDivisions.length || state.includeDivisions.indexOf(entry.competitionDivisionID) > -1
}, {
  id: 'includeDays',
  description: 'Competition Days',
  options: (state, filteredEntries) => props.competitionDays.filter(day => filteredEntries.some(e => e.competitionDayID === day.id) || state.includeDays.indexOf(day.id) > -1).map(d => ({
    id: d.id,
    description: (0, _occasion.default)(d.dayDate, 'dddd')
  })),
  check: (state, entry) => !state.includeDays.length || state.includeDays.indexOf(entry.competitionDayID) > -1
}, {
  id: 'includeEntryTypes',
  description: 'Entry Types',
  options: (state, filteredEntries) =>
  // only show entry types that are actually in use to avoid confusion
  props.entryTypeOverrides.filter(entryType => filteredEntries.some(e => e.entryTypeID === entryType.entryTypeID) || state.includeEntryTypes.indexOf(entryType.id) > -1).map(et => ({
    id: et.entryTypeID,
    description: et.entryTypeDescription
  })),
  check: (state, entry) => !state.includeEntryTypes.length || state.includeEntryTypes.indexOf(entry.entryTypeID) > -1
},
// races filter based on race name rather than raceID as feels 'odd' to user if done by id
// races Sunday often mirror Saturday.
{
  id: 'includeRaces',
  description: 'Races',
  options: (state, filteredEntries) => {
    const raceNames = props.races.filter(race => filteredEntries.some(e => e.race.raceName === race.raceName) || state.includeRaces.indexOf(race.raceName) > -1).map(r => r.raceName);
    const uniqueRaceNames = [...new Set(raceNames)];
    return uniqueRaceNames.map(raceName => ({
      id: raceName,
      description: raceName
    }));
  },
  check: (state, entry) => !state.includeRaces.length || state.includeRaces.indexOf(entry.race.raceName) > -1
}];
// *******************************************************************************
// Email Fields
// *******************************************************************************
const emailFields = [{
  id: 'contactEmail',
  description: 'Contact',
  default: true,
  emailAddresses: entry => [entry.contactEmail]
}];

// *******************************************************************************
// Main Component
// *******************************************************************************
const initialState = {
  showEmails: false
};
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "When sending group emails always use back copy (bcc) to keep the email addresses private."), /*#__PURE__*/_react.default.createElement("p", null, "For large groups consider splitting into multiple emails to avoid spam filters"));
class SendGroupEmail extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onCloseModal", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_onOpenModal", entries => {
      this.setState({
        showEmails: true
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("span", null, !this.state.showEmails ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Emails for ' + this.props.entryGroup,
      size: "lg",
      onClose: this._onCloseModal
    }, _ref, /*#__PURE__*/_react.default.createElement(_groupEmail.default, {
      flags: flags,
      filterSets: filterSets(this.props),
      emailFields: emailFields,
      dataRecords: this.props.entries,
      sender: this.props.organiserEmail,
      emailSubject: this.props.competitionName,
      onSend: this._onCloseModal
    })), !this.props.entries.length ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        marginBottom: 8
      },
      size: "md",
      onClick: value => this._onOpenModal(this.props.entries)
    }, "Send Group Emails"));
  }
  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(SendGroupEmail, "partialQueries", {
  Competition: {
    competitionName: true,
    organiserEmail: true,
    competitionDivisions: {
      id: true,
      description: true
    },
    competitionDays: {
      id: true,
      dayDate: true
    },
    entryTypeOverrides: {
      entryTypeID: true,
      entryTypeDescription: true
    },
    races: {
      id: true,
      raceName: true
    }
  },
  Entry: {
    id: true,
    contactEmail: true,
    isOnlineEntry: true,
    competitionDivisionID: true,
    competitionDayID: true,
    hasPaid: true,
    isLateEntry: true,
    rtcRefs: true,
    race: {
      raceName: true
    }
  }
});
var _default = exports.default = SendGroupEmail;